import { render } from "./StatsTodayItem.vue?vue&type=template&id=d9b07e24"
import script from "./StatsTodayItem.vue?vue&type=script&lang=js"
export * from "./StatsTodayItem.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/nuxt-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__